import { IconFont } from '@/components'
import { Spin } from 'antd'
import { memo, Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { Content, Footer, Main } from './style'
import logo from '@/assets/logo.jpg'
import recordImg from '@/assets/entrance/record.png'

export default memo(function EntranceLayout() {
	const year = new Date().getFullYear()

	return (
		<Main>
			<Content>
				<div className='inner'>
					<div className='logo-content'>
            <div className='new-icon-logo-inner'>
              <img height={100} src={logo} />
            </div>
					</div>
					<div className='form'>
						<Suspense fallback={<Spin size='large' tip='Loading...' />}>
							<Outlet />
						</Suspense>
					</div>
				</div>
			</Content>

			<Footer>
				<section>
					<ul className='list'>
						<li>
							<IconFont type='icon-fast' /> 快速使用
						</li>
						<li>
							<IconFont type='icon-team' /> 专业化团队
						</li>
						<li>
							<IconFont type='icon-device' /> 专业设备
						</li>
					</ul>

					<section className='desc'>
						{/* <img className='qrcode' src={QRCode} /> */}

						<div className='context'>
							<h1>智云车 让汽车租赁更简单</h1>
							<p>中小汽车租赁企业“设备+云平台”一站式解决方案</p>
						</div>
					</section>

					<section className='copyright'>
						<a href='https://beian.miit.gov.cn' target='_blank'>
							<img src={recordImg} style={{ marginRight: '5px' }} />
                京ICP备2025131439
						</a>
					</section>
				</section>
			</Footer>
		</Main>
	)
})
